export const videoServices = [
  {
    id: 1,
    key: 'vimeo',
    label: 'Vimeo',
    base: 'https://player.vimeo.com/video/'
  }
]